/*global _, archiuiApp, URL*/
archiuiApp
  .factory('SearchService', function ($http, $location, $window, dateFilter, ATTS, ENDPOINT_SEARCH, ENDPOINT_AGGREGATE) {
    var service = {}
    service.recuperaDati = function (keywords, filtri, currentPage, itemsPerPage, sort, table) {
      return $http.post(ENDPOINT_SEARCH, {
        'table': 'data',
        'limit': itemsPerPage,
        'skip': currentPage * itemsPerPage,
        'sort': sort || {
          'score': {
            $meta: 'textScore'
          }
        },
        'fields': {
          'id': 1,
          'preferred_label': 1,
          // 'representations': 1,
          'metadati.biografia': 1,
          'metadati.desc_contenuto': 1,
          'numero': 1,
          'data': 1,
          'table': 1,
          'filtri': 1,
          'type': 1,
          'archivio': 1,
          'score': {
            $meta: 'textScore'
          }
        },
        'query': queryFiltri(keywords, filtri, currentPage, table)
      })
    }
    service.recuperaFiltri = function (keywords, filtri, currentPage, table) {
      if (filtri.length < 1) {
        filtri = [{}]
      }
      return $http.post(ENDPOINT_AGGREGATE, {
        'table': 'data',
        'query': [{
          '$match': queryFiltri(keywords, filtri, currentPage, table)
        }, {
          '$unwind': '$filtri'
        }, {
          '$group': {
            '_id': '$filtri',
            'count': {
              '$sum': 1
            }
          }
        }, {
          '$project': {
            '_id': 0,
            'count': 1,
            'data': '$_id'
          }
        }]
      })
    }

    service.getFiltriSelezionati = function (s = null) {
      var result = []
      var search = s || $location.search()
      if (search.types) {
        search.types = _.isArray(search.types) ? search.types : [search.types]
        _.each(search.types, function (key) {
          var split = _.split(key, '|')
          result.push({
            'data': {
              'name': split[0],
              'id': split[1],
              'path': split[2]
            }
          })
        })
      }
      if (search.dates_from || search.dates_to) {
        var filtro = {'cronologia': {}}
        if (search.dates_from) {
          filtro.cronologia.from = new Date(search.dates_from)
        }
        if (search.dates_to) {
          filtro.cronologia.to = new Date(search.dates_to)
        }
        result.push(filtro)
      }
      return result
    }

    service.getKeywords = function (s = null) {
      var result = []
      var search = s || $location.search()
      var keywords = search.keywords
      if (_.isEmpty(search.keywords)) {
        keywords = new URL($location.absUrl()).searchParams.get('keywords')
      }
      if (keywords) {
        keywords = _.isArray(keywords) ? keywords : [keywords]
        _.each(keywords, function (key) {
          result.push({
            'text': key
          })
        })
      }

      return result
    }

    service.getLastDate = function (keywords, filtri, currentPage, table) {
      var freezfiltri = filtri.slice(0)
      var fil = filtri.filter(function (o) {
        return Boolean(o.cronologia) === false
      })
      let query = queryFiltri(keywords, fil, currentPage, table, freezfiltri)
      query['data.end'] = {'$exists': true}
      query['data.value'] = {'$ne': 's.d.'}      
      return $http.post(ENDPOINT_SEARCH, {
        'table': ATTS.table,
        'limit': 1,
        'skip': 0,
        'sort': {'data.start': -1},
        'fields': {
          'data': 1
        },
        'query': query
      })
    }

    service.getFirstDate = function (keywords, filtri, currentPage, table) {
      var freezfiltri = filtri.slice(0)
      var fil = filtri.filter(function (o) {
        return Boolean(o.cronologia) === false
      })
      let query = queryFiltri(keywords, fil, currentPage, table, freezfiltri)
      query['data.start'] = {'$exists': true}
      query['data.value'] = {'$ne': 's.d.'}      
      return $http.post(ENDPOINT_SEARCH, {
        'table': ATTS.table,
        'limit': 1,
        'skip': 0,
        'sort': {'data.start': 1},
        'fields': {
          'data': 1
        },
        'query': query
      })
    }

    return service

    function queryFiltri (keywords, filtri, currentPage, table, ignoreDate) {
      ignoreDate = ignoreDate || false
      var query = {
        'access': {$in: [1]},
        'table': table === 'objects' ? {$in: ['ca_objects', 'ca_occurrences']} : {$in: ['ca_entities']}
      }

      var search = {
        'currentPage': currentPage,
        'table': table
      }
      var types = _.filter(filtri, function (o) {
        return !!o.data
      })

      /* var keywords = _.filter(filtri, function(o) {
           return !!o.keyword
       });*/
      var dates = _.filter(filtri, function (o) {
        return !!o.cronologia
      })
      if (!_.isEmpty(types)) {
        query['filtri.id'] = {
          '$all': _.map(types, function (item) {
            return item.data.id
          })
        }

        search.types = _.map(types, function (item) {
          return item.data.name + '|' + item.data.id + '|' + item.data.path
        })
      }

      if (!_.isEmpty(keywords)) {

        var regex = _.chain(keywords)
        .filter(e => _.endsWith(e.text, '*'))
        .map(e => {
          return '(?=\\b' + _.replace(e.text, '*', '.*') + '\\b)'
        })
        .join('')
        .value()

        if (regex) {
          query.search = {
            '$regex' : '/' + regex + '.*/',
            '$options' : 'si'
          }
        }

        var queryString = _.chain(keywords)
          .filter(e => !_.endsWith(e.text, '*'))
          .map(e => {
            if (!_.startsWith(e.text, '"') && !_.endsWith(e.text, '"')) {
              return _.split(e.text, ' ')
            } else {
              return _.trim(e.text, '"')
            }
          })
          .flattenDeep()
          .map(e => '\"' + e + '\"')
          .join(' ')
          .value()

        if (queryString) {
          query.$text = {
            '$search' :queryString
          }
        }

        search.keywords = _.map(keywords, 'text')
      }

      if (!_.isEmpty(dates)) {
        let cronologia = dates[0].cronologia
        query['data.start'] = {}
        if (cronologia.from) {
          query['data.start'].$gte = dateFilter(cronologia.from, 'yyyy-MM-dd')
          search.dates_from = query['data.start'].$gte
        }
        if (cronologia.to) {
          query['data.start'].$lt = dateFilter(cronologia.to, 'yyyy-MM-dd')
          search.dates_to = query['data.start'].$lt
        }
      }

      if (ignoreDate) {
        let cronologia = _.filter(ignoreDate, function (o) {
          return !!o.cronologia
        })
        if (!_.isEmpty(cronologia)) {
          cronologia = cronologia[0].cronologia
          if (cronologia.from) {
            search.dates_from = dateFilter(cronologia.from, 'yyyy-MM-dd')
          }
          if (cronologia.to) {
            search.dates_to = dateFilter(cronologia.to, 'yyyy-MM-dd')
          }
        }
      }

      $location.search(search)

      // Salvo le informazioni sulla cache
      let url = new URL($window.location.href)
      if (!url.searchParams.has('id')) {
        $window.sessionStorage.setItem('search', JSON.stringify(search))
      }
      return query
    }
  })



// WEBPACK FOOTER //
// ./src/js/pages/search.service.js